import React, { useState, useContext, useEffect } from "react";
import styles from "./styles/SideTicket.module.css";
import DataContext from "../../../context/DataContext";
import { formatDateToLocalDate } from "../../../utils/utils";
import { calculateValues } from "../../../utils/utils";
import { ReactComponent as Pointer } from "../../../assets/triangle.svg";
import useNumberFormat from "../../../hooks/useNumberFormat";
import { ReactComponent as IconClock } from "../../../assets/clock.svg";
import { ReactComponent as IconTicket } from "../../../assets/ticket.svg";
import { ReactComponent as IconBill } from "../../../assets/bill-1.svg";
/**
 * SideTicket component
 */
const SideTicket = ({
    ticket,

    currency,
    searched,
    handleCheckFunction,
    clickedTicket,
    handleClickedTicket,
}) => {
    const {
        setCurrentTicket,
        setCurrentCategory,
        setTicketType,
        isPayHover,
        selectedInstalments,
        selectedTickets,
        connection,
    } = useContext(DataContext);

    const [isChecked, setIsChecked] = useState(false);

    useEffect(() => {
        const current = selectedTickets?.filter(
            (item) => item?.ticketNumber === ticket?.ticketNo,
        );

        setIsChecked(current?.length > 0);
    }, [selectedTickets]);

    const onClickHandle = () => {
        setCurrentTicket(ticket);
        setTicketType(0);
        setCurrentCategory(ticket?.photos?.[0]?.category);
        handleClickedTicket(ticket?.ticketNo);
    };

    const { total } = calculateValues(
        ticket?.paymentBalance,
        ticket?.amount,
        ticket?.transactionItems,
    );

    const formatNum = useNumberFormat();

    return (
        <button
            className={`${styles.main_ticket_container} 
           
            ${
                clickedTicket === ticket?.ticketNo && styles.clicked
            } flex-container`}
            onClick={() => onClickHandle()}
        >
            <div className={`${styles.input_check_container} flex-container`}>
                {connection?.isPayment ? (
                    <input
                        data-ticketdate={ticket?.from_DateTime}
                        data-offences={JSON.stringify(ticket?.offences)}
                        className={`${styles.input_check_element}`}
                        type="checkbox"
                        name={ticket?.ticketNo}
                        id={ticket?.ticketNo}
                        value={total}
                        onChange={handleCheckFunction}
                        checked={isChecked || false}
                    />
                ) : (
                    <></>
                )}
                <Pointer
                    className={`${styles.input_check_highlight} 
                    ${
                        isPayHover &&
                        !selectedInstalments.length &&
                        !selectedTickets.length
                            ? styles.arrowFadeIn
                            : styles.arrowFadeOut
                    }
                    `}
                />
                <label
                    className={`${styles.input_check_label}`}
                    htmlFor={ticket?.ticketNo}
                    aria-label={`Check input for ticket id ${ticket?.ticketNo}`}
                ></label>
            </div>

            <div className={`${styles.info_container} v-flex-container`}>
                <div
                    className={`${styles.ticket_info}  ${styles.ticket_hide_info} flex-container`}
                >
                    <span>
                        <IconBill
                            className={`${styles.ticket_icon} icon-component`}
                        />
                    </span>
                    {`${currency}${formatNum(total)}`}
                </div>

                <div className={`${styles.ticket_info}  flex-container`}>
                    <span>
                        <IconTicket
                            className={`${styles.ticket_icon} icon-component`}
                        />
                    </span>
                    {ticket?.ticketNo}
                </div>

                <div
                    className={`${styles.ticket_info} ${styles.ticket_hide_info}  flex-container`}
                >
                    <span>
                        <IconClock
                            className={`${styles.ticket_icon} icon-component`}
                        />
                    </span>
                    {formatDateToLocalDate(ticket?.from_DateTime)}
                </div>
            </div>
        </button>
    );
};

export default SideTicket;
